import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AnnouncementBannerComponent } from './shared/layout/announcement-banner.component';
import { HeaderComponent } from './shared/layout/header.component';
import { SidebarComponent } from './shared/layout/sidebar.component';
import { ShellStore } from './shared/layout/shell.store';

@Component({
  selector: 'app-root',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [RouterOutlet, AnnouncementBannerComponent, HeaderComponent, SidebarComponent],
  template: `
    <app-announcement-banner />
    <div class="shell" [class.sidebar-collapsed]="store.sidebarCollapsed()">
      <app-header />
      <app-sidebar [collapsed]="store.sidebarCollapsed()" [sections]="store.sections()" />
      <main class="shell-content">
        <router-outlet />
      </main>
    </div>
  `,
  styles: [`
    :host {
      display: flex;
      flex-direction: column;
      min-height: 100dvh;
    }

    .shell {
      display: grid;
      flex: 1;
      grid-template-rows: var(--header-h) 1fr;
      grid-template-columns: var(--sidebar-w) 1fr;
      grid-template-areas:
        "header  header"
        "sidebar content";
      background: var(--bg);
    }

    .shell.sidebar-collapsed {
      grid-template-columns: var(--sidebar-w-collapsed) 1fr;
    }

    .shell-content {
      grid-area: content;
      overflow-y: auto;
      padding: 2rem 2.5rem;
      color: var(--text);
      min-height: 0;
    }
  `],
})
export class AppComponent {
  protected readonly store = inject(ShellStore);
}
